import React from "react";
import createSvgIcon from "@material-ui/core/utils/createSvgIcon";

/**
 * author: Google
 * id 73FBEFFD-7EE3-4272-AB1F-A480C698FD5E
 * name door-sliding
 * version: 6.1.95
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/door-sliding.svg
 * tags
 * - Home Automation 
 */
export const DoorSlidingIcon = createSvgIcon(<><path d="M10 13H8V11H10V13M16 11H14V13H16V11M21 19V21H3V19H4V5C4 3.9 4.9 3 6 3H18C19.1 3 20 3.9 20 5V19H21M11 5H6V19H11V5M18 5H13V19H18V5Z" /></>, 'DoorSlidingIcon');
export default DoorSlidingIcon